
import ProfileDropdown from '@/views/layouts/navigation/ProfileDropdown.vue'
import { getCurrentInstance, onMounted, ref, defineComponent, computed, reactive } from 'vue'
import { useRoute } from 'vue-router'
import {
  useStore
} from 'vuex'
import Button from 'primevue/button'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import CountDown from '@/views/components/countdown/Countdown.vue'
import { checkProhibitedRoles } from '@/utils/helpers/checkProhibitedRole'
import environment from '@/configs/environtment'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'

export default defineComponent({
  name: 'HeaderPanel',
  components: {
    ProfileDropdown,
    Button,
    // CountDown
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const app = getCurrentInstance()
    const data = ref({}) as any
    const {
      $icon
    } = app!.appContext.config.globalProperties
    const icon = $icon
    const minimizeMenu = computed({
      get: () => store.state.toggleMinimizeMenu,
      set: (val) => {
        store.dispatch('setToggleMinimizeMenu', val)
      }
    })

    const emitToggle = (val: any) => {
      if (minimizeMenu.value === false && store.state.toggleMenu) {
        minimizeMenu.value = true
      } else {
        store.dispatch('setToggleMenu', val)
        minimizeMenu.value = false
      }
      console.log('store', store.state)
    }

    const showFormDialog = computed({
      get: () => store.state.headerButton.isShowDialogForm,
      set: (val) => {
        store.dispatch('setHeaderButtonActionShowDialogForm', val)
      }
    })

    const fetchUserEmploymentAndBuilding = async () => {
      store.dispatch('showLoading')
      try {
        const employeeEndpoint = 'talent/v1/employees'
        const employmentEndpoint = 'talent/v1/employments'
        const buildingEndpoint = 'talent/v1/buildings'
        const uid = encryptDecriptMethods.decrypt(localStorage.getItem('ud'))
        const responseEmployee = await apiOpenUseCase.get(`${employeeEndpoint}?authUserId=${uid}`)
        if (responseEmployee.result?.data.length > 0) {
          console.log('responseEmployee', responseEmployee.result.data[0])
          if (responseEmployee.result.data[0].latestEmployment) {
            console.log('employment', responseEmployee.result.data[0].latestEmployment)
            const userEmployment = responseEmployee.result.data[0].latestEmployment
            console.log('userEmployment', userEmployment)
            if (userEmployment) {
              const employmentId = userEmployment.id
              const responseEmployment = await apiOpenUseCase.get(`${employmentEndpoint}/${employmentId}`)
              if (responseEmployment.result) {
                store.dispatch('userProfiles/setUserEmployment', responseEmployment.result)
                const buildingId = responseEmployment.result.buildingId
                const buildingName = responseEmployment.result.buildingName
                store.dispatch('userProfiles/setUserBuilding', { id: buildingId, name: buildingName })
              }
            }
          }
        }
        store.dispatch('hideLoading')
      } catch (error) {
        console.log('error', error)
        store.dispatch('hideLoading')
      }
      console.log('store', store.state)
    }

    const openFormDialog = () => {
      showFormDialog.value = true
      console.log('storeAfter', store.state)
    }

    onMounted(() => {
      store.dispatch('fetchProfile')
      // fetchUserEmploymentAndBuilding()
      store.dispatch('userProfiles/fetchUserEmploymentAndBuilding')
      // store.dispatch('fetchGlobalSettingHjex')
      store.dispatch('globalSetting/fetchGlobalSetting')
    })

    return {
      emitToggle,
      route,
      data,
      icon,
      store,
      openFormDialog,
      checkProhibitedRoles
      // $icon
    }
  }
})
